@if (mappedRide(); as _mappedRide) {
  <div
    class="item"
    #item>
    <div
      class="grid-layout-container"
      [ngClass]="{ 'grid-layout-actions-container-xs': !appSetting['hasDriverMessagingPermission'] && !appSetting['hasGuardianMessagingPermission'] }">
      <div class="ride-details ride-serial justify-content-center">
        <span
          style="min-width: fit-content; height: 20px"
          class="flex justify-content-center align-items-center text-caption-color px-spacing-default border-round background-muted-secondary-bg border-1 border-neutral-base-primary-border label-medium-regular">
          {{ (index() + 1).toString() }}
        </span>
      </div>
      @if (currentRole == userRole.Client) {
        <div class="ride-details ride-students justify-content-center">
          <span
            class="name label-medium-regular text-caption-color"
            [pTooltip]="_mappedRide.studentNames[0]"
            [tooltipOptions]="tooltipOptions">
            {{ _mappedRide.studentNames[0] }}
          </span>
          @if (_mappedRide.studentNames.length > 1) {
            <span
              class="name label-medium-regular text-caption-color"
              [pTooltip]="_mappedRide.studentNames[1]"
              [tooltipOptions]="tooltipOptions">
              {{ _mappedRide.studentNames[1] }}
            </span>
          }
          @if (_mappedRide.studentNames.length > 2) {
            <button
              (click)="openStudentsListDialog(_mappedRide.studentNames)"
              class="label-medium-regular text-link-color text-inverse-bg border-none p-0">
              See More
            </button>
          }
        </div>
      }
      <div class="ride-details ride-info">
        @if (currentRole != userRole.Client) {
          <span class="title label-large-medium text-primary-color">{{ _mappedRide.id }}</span>
        }
        <span class="sub-title label-medium-regular text-caption-color uppercase">{{ _mappedRide.rideInfo.type }}</span>
        @if (_mappedRide.rideInfo.tag) {
          <app-tag
            class="ride-info-tag"
            [content]="_mappedRide.rideInfo.tag || ''"
            sizeClass="tag-sm"
            severityClass="secondary"></app-tag>
        }
        <app-tag
          class="ride-status-tag-sm"
          styleClass="bold"
          [content]="_mappedRide.rideStatus"
          sizeClass="tag-sm"
          [severityClass]="currentRole == userRole.Client && _mappedRide.rideStatus == 'Driver not Assigned' ? 'secondary' : _mappedRide.rideStatusSeverity"
          [pTooltip]="_mappedRide.attentionTooltip?.hasAttention ? statusTooltip : _mappedRide.rideStatus"
          [tooltipOptions]="tooltipOptions"></app-tag>
      </div>
      <div class="ride-details ride-time">
        <span class="title label-large-medium text-primary-color"> {{ _mappedRide.rideTime.from }} - {{ _mappedRide.rideTime.to }} </span>
        <div class="flex align-items-center gap-spacing-xs">
          <span class="sub-title label-medium-regular text-caption-color">{{ _mappedRide.rideTime.utcTimezoneDiff }}</span>
          @if (isPendingRides()) {
            <span class="sub-title label-medium-regular text-caption-color">{{ ride().index_date_of_service }}</span>
          }
        </div>
        @if (_mappedRide.driverDetails && _mappedRide.driverDetails.id != partnerBotId()) {
          <div class="driver-info-sm">
            <div class="driver-info">
              <app-user-avatar
                [active]="driverAvailability() || false"
                size="xsm"
                [label]="driverImg().startsWith('data') ? '' : _mappedRide.driverDetails.name[0]"
                [imgSrc]="driverImg()"></app-user-avatar>
              <span
                [pTooltip]="_mappedRide.driverDetails.name"
                [tooltipOptions]="tooltipOptions"
                class="driver-name title label-large-medium text-primary-color">
                {{ _mappedRide.driverDetails.name.length <= 15 ? _mappedRide.driverDetails.name : (_mappedRide.driverDetails.name | slice: 0 : 15) + "..." }}
              </span>
            </div>
          </div>
        } @else {
          <div class="driver-info-sm no-driver">
            <app-tag
              content="Driver not assigned"
              sizeClass="tag-sm"
              [styleClass]="currentRole == userRole.Client ? 'bold' : 'light'"
              [severityClass]="currentRole == userRole.Client ? 'secondary' : 'danger'"></app-tag>
          </div>
        }
      </div>
      <div class="ride-details ride-status justify-content-center">
        <app-tag
          styleClass="bold"
          [content]="_mappedRide.rideStatus"
          sizeClass="tag-sm"
          [severityClass]="_mappedRide.rideStatus == 'Driver not Assigned' && currentRole == userRole.Client ? 'secondary' : _mappedRide.rideStatusSeverity"
          [pTooltip]="_mappedRide.attentionTooltip?.hasAttention ? statusTooltip : _mappedRide.cancellationReasonDetails ? cancellationReasonDetailsTemplate : _mappedRide.rideStatus"
          [tooltipOptions]="tooltipOptions"></app-tag>
        @if (currentRole == userRole.Client) {
          <span
            class="flex align-items-center gap-spacing-3xs p-spacing-default border-feedback-info-border border-round-sm label-medium-medium"
            [ngClass]="{
              'feedback-gray-bg-bg feedback-gray-fg-color': !_mappedRide.numOfPickedUpStudents,
              'text-link-color background-muted-info-bg': _mappedRide.numOfPickedUpStudents
            }"
            style="height: 20px; width: fit-content">
            <i class="icon-backpack size-icon-sm"></i> {{ _mappedRide.numOfPickedUpStudents }}
          </span>
        }
      </div>
      <div class="ride-details ride-timeline">
        <div
          class="timeline-container"
          [style]="'--steps: ' + _mappedRide.rideTimeline.length">
          <app-stepper
            [steps]="_mappedRide.rideTimeline"
            [activeStep]="_mappedRide.rideStatus | activeStep: _mappedRide.rideTimeline"></app-stepper>
        </div>
      </div>
      @if (_mappedRide.driverDetails && _mappedRide.driverDetails.id != partnerBotId()) {
        <div class="ride-details driver-details">
          <div class="flex align-items-center gap-spacing-xs justify-content-between">
            <div class="driver-info">
              <app-user-avatar
                [active]="driverAvailability() || false"
                size="xsm"
                [label]="driverImg().startsWith('data') ? '' : _mappedRide.driverDetails.name[0]"
                [imgSrc]="driverImg()"></app-user-avatar>
              <span
                [pTooltip]="_mappedRide.driverDetails.name"
                [tooltipOptions]="tooltipOptions"
                class="driver-name title label-large-medium text-primary-color">
                {{ _mappedRide.driverDetails.name!.length <= 15 ? _mappedRide.driverDetails.name : (_mappedRide.driverDetails.name | slice: 0 : 15) + "..." }}
              </span>
            </div>
            @if (_mappedRide.monitorDetails) {
              <span
                [pTooltip]="monitorDetailsTooltip"
                tooltipPosition="bottom"
                [autoHide]="false"
                class="flex align-items-center gap-spacing-3xs text-link-color p-spacing-default background-muted-info-bg border-1 border-feedback-info-border border-round-sm"
                style="height: 20px">
                <i class="icon-eye-solid"></i> M
              </span>
            }
          </div>
          <app-info-group
            [firstValue]="_mappedRide.driverDetails.type"
            [secondValue]="_mappedRide.driverDetails.number"
            (viewDetails)="openContractorDialog()"></app-info-group>
          @if (currentRole == userRole.Client) {
            <app-info-group
              [firstValue]="'Plate #'"
              [secondValue]="_mappedRide.driverDetails.plateNumber"
              [tooltipTemplate]="vehicleDetailsTooltip">
            </app-info-group>
          } @else {
            <span class="label-medium-regular text-caption-color overflow-hidden text-overflow-ellipsis white-space-nowrap">{{ _mappedRide.driverDetails.driverProvider }}</span>
          }
        </div>
      } @else {
        <div class="ride-details driver-details no-driver">
          <app-tag
            [styleClass]="currentRole == userRole.Client ? 'bold' : 'light'"
            content="Driver not assigned"
            sizeClass="tag-sm"
            [severityClass]="currentRole == userRole.Client ? 'secondary' : 'danger'"></app-tag>
          @if (_mappedRide.monitorDetails) {
            <span
              [pTooltip]="monitorDetailsTooltip"
              tooltipPosition="bottom"
              [autoHide]="false"
              class="flex align-items-center gap-spacing-3xs text-link-color p-spacing-default background-muted-info-bg border-1 border-feedback-info-border border-round-sm"
              style="height: 20px">
              <i class="icon-eye-solid"></i> M
            </span>
          }
        </div>
      }
      <div class="ride-details client-details">
        <div class="flex gap-spacing-xs align-items-center justify-content-between">
          @if (_mappedRide.clientDetails && _mappedRide.clientDetails.length > 0) {
            <span
              [pTooltip]="_mappedRide.clientDetails[0].name"
              [tooltipOptions]="tooltipOptions"
              class="title label-large-medium text-primary-color">
              {{ _mappedRide.clientDetails[0].name }}
            </span>
          }
          @if (_mappedRide.clientDetails.length > 1) {
            <span
              [pTooltip]="clientListTooltip"
              tooltipPosition="bottom"
              [autoHide]="false"
              class="flex align-items-center gap-spacing-3xs text-link-color p-spacing-default background-muted-info-bg border-1 border-feedback-info-border border-round-sm"
              style="height: 20px">
              +{{ _mappedRide.clientDetails.length - 1 }}
            </span>
          }
        </div>
        <app-info-group
          [firstValue]="'Blueprint'"
          [secondValue]="_mappedRide.blueprintId.toString()"
          (viewDetails)="openBlueprintDialog()"></app-info-group>
        <div class="car-type">
          <span class="icon icon-car-solid"></span>
          <span class="sub-title label-medium-regular text-caption-color">{{ _mappedRide.driverDetails?.blueprintCarType }}</span>
          @if (appSetting.hasEquipmentDetailsPermission) {
            <span
              [pTooltip]="equipmentsTooltip"
              tooltipPosition="bottom"
              [autoHide]="false"
              class="flex align-items-center gap-spacing-3xs p-spacing-3xs border-1 border-round-sm"
              [ngClass]="{
                'icon-lightest-color icon-lightest-border': _mappedRide.equipmentsNeed?.equipmentsNeed == equipmentsNeed.NoEquipmentRequired,
                'icon-danger-color icon-danger-border': _mappedRide.equipmentsNeed?.equipmentsNeed == equipmentsNeed.RequiredButNotAssigned,
                'icon-success-subtle-color icon-success-subtle-border': _mappedRide.equipmentsNeed?.equipmentsNeed == equipmentsNeed.RequiredAndAssigned
              }">
              <svg
                [ngClass]="{
                  'icon-lightest-fill': _mappedRide.equipmentsNeed?.equipmentsNeed == equipmentsNeed.NoEquipmentRequired,
                  'icon-danger-fill': _mappedRide.equipmentsNeed?.equipmentsNeed == equipmentsNeed.RequiredButNotAssigned,
                  'icon-success-subtle-fill': _mappedRide.equipmentsNeed?.equipmentsNeed == equipmentsNeed.RequiredAndAssigned
                }"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none">
                <path
                  d="M14.7202 6.94212C15.0015 6.66082 15.1596 6.27929 15.1596 5.88146C15.1596 5.48364 15.0015 5.10211 14.7202 4.8208L11.8918 1.99237C11.6411 1.74556 11.3117 1.59471 10.9611 1.56617C10.6104 1.53764 10.2609 1.63325 9.97366 1.83628C9.68638 2.03931 9.4796 2.33685 9.38947 2.67689C9.29933 3.01693 9.33157 3.37783 9.48055 3.6965L5.88138 7.29568C5.47377 7.70312 5.21946 8.23887 5.16147 8.81228C5.10349 9.38568 5.2454 9.96151 5.56318 10.4423C5.55077 10.4534 5.53897 10.4652 5.52783 10.4777L3.76006 12.2454C3.66629 12.1517 3.53912 12.099 3.40651 12.099C3.2739 12.099 3.14672 12.1517 3.05295 12.2454C2.95919 12.3392 2.90651 12.4664 2.90651 12.599C2.90651 12.7316 2.95919 12.8588 3.05295 12.9525L3.76006 13.6596C3.85383 13.7534 3.98101 13.8061 4.11361 13.8061C4.24622 13.8061 4.3734 13.7534 4.46717 13.6596C4.56094 13.5659 4.61361 13.4387 4.61361 13.3061C4.61361 13.1735 4.56094 13.0463 4.46717 12.9525L6.23493 11.1848C6.24735 11.1736 6.25915 11.1618 6.27029 11.1494C6.75109 11.4672 7.32691 11.6091 7.90031 11.5511C8.47372 11.4931 9.00947 11.2388 9.41691 10.8312L13.0161 7.23204C13.2953 7.36541 13.609 7.40914 13.9141 7.35724C14.2192 7.30533 14.5008 7.16034 14.7202 6.94212ZM10.8311 8.00278L8.70981 5.88146L10.124 4.46725L12.2453 6.58857L10.8311 8.00278ZM6.58849 10.1241C6.30718 9.8428 6.14915 9.46127 6.14915 9.06344C6.14915 8.66562 6.30718 8.28409 6.58849 8.00278L8.0027 6.58857L10.124 8.70989L8.70981 10.1241C8.4285 10.4054 8.04697 10.5634 7.64915 10.5634C7.25132 10.5634 6.86979 10.4054 6.58849 10.1241Z" />
              </svg>
            </span>
          }
        </div>
      </div>
      @if (appSetting.hasCameraIconPermission) {
        <div class="ride-details camera-status">
          @if (_mappedRide.driverDetails && _mappedRide.driverDetails.id != partnerBotId()) {
            <!--camera required (_mappedRide.isCameraRequired) -->
            @if (_mappedRide.isCameraRequired) {
              @if (cameraId()) {
                <!-- 1 - camerid -->
                <app-tag
                  (tagClick)="cameraId() && isCameraDialogEnabled() ? openCameraDialog(cameraOnlineStatus(), lastSyncDate()) : null"
                  [ngClass]="{ 'cursor-pointer': cameraId() && isCameraDialogEnabled() }"
                  styleClass="bold"
                  [content]="cameraOnlineStatus() ? 'Required - On' : 'Required - Off'"
                  sizeClass="tag-sm"
                  [severityClass]="cameraOnlineStatus() ? 'success' : 'danger'"
                  [pTooltip]="(cameraOnlineStatus() ? 'Active' : 'Offline') + (lastSyncDate() ? ' - Last Sync ' + (lastSyncDate()! | date: 'h:mm a') : '')"
                  [tooltipOptions]="tooltipOptions"
                  [iconStart]="'icon-video-camera-solid'">
                </app-tag>
              } @else {
                <!-- 2 - no cameraid -->
                <app-tag
                  styleClass="bold"
                  [content]="'Required - Not Installed'"
                  sizeClass="tag-sm"
                  [severityClass]="'secondary'"
                  [pTooltip]="'Required - Not Installed'"
                  [tooltipOptions]="tooltipOptions"
                  [iconStart]="'icon-video-camera-slash-solid'"></app-tag>
              }
            } @else {
              <!--camera not required (!_mappedRide.isCameraRequired) no need to check camera install or not (po:confirmed) -->
              <!-- not required -->
              <app-tag
                styleClass="bold"
                [content]="'Not Required'"
                sizeClass="tag-sm"
                [severityClass]="'info'"
                [iconStart]="'icon-video-camera-slash-solid'">
              </app-tag>
            }
          } @else {
            <app-tag
              styleClass="bold"
              [content]="_mappedRide.isCameraRequired ? 'Required' : 'Not Required'"
              sizeClass="tag-sm"
              [severityClass]="'info'"
              [iconStart]="_mappedRide.isCameraRequired ? 'icon-video-camera-solid' : 'icon-video-camera-slash-solid'">
            </app-tag>
          }
        </div>
      }
      <!-- action column -->
      <div
        class="ride-details actions-container justify-content-center gap-spacing-md align-items-end"
        [ngClass]="{ 'actions-container-xs': !appSetting['hasDriverMessagingPermission'] && !appSetting['hasGuardianMessagingPermission'] }">
        <div class="flex gap-spacing-xl actions-wrapper">
          @if (appSetting["hasDriverMessagingPermission"] || appSetting["hasGuardianMessagingPermission"]) {
            <div class="flex gap-spacing-xs justify-content-center btns-group btns-group-1">
              @if (appSetting["hasDriverMessagingPermission"]) {
                <app-button
                  pTooltip="Driver Messages"
                  [tooltipOptions]="tooltipOptions"
                  [iconOnlyButton]="true"
                  icon="icon-car-solid"
                  sizeClass="p-button-sm"
                  severity="primary"
                  [textButton]="true"
                  [disabled]="!_mappedRide.driverDetails || _mappedRide.driverDetails.id == partnerBotId()"
                  (btnClick)="openMessagingDialog('contractor', false, _mappedRide)">
                </app-button>
              }
              @if (appSetting["hasGuardianMessagingPermission"]) {
                <app-button
                  pTooltip="Guardian Messages"
                  [tooltipOptions]="tooltipOptions"
                  [iconOnlyButton]="true"
                  icon="icon-person-solid"
                  sizeClass="p-button-sm"
                  severity="primary"
                  [textButton]="true"
                  [disabled]="false"
                  (btnClick)="openMessagingDialog('guardian', false, _mappedRide)">
                </app-button>
              }
            </div>
          }
          <div class="flex gap-spacing-xs justify-content-center btns-group btns-group-1">
            <app-button
              pTooltip="Ride Activity"
              [tooltipOptions]="tooltipOptions"
              [iconOnlyButton]="true"
              icon="icon-file-text-solid"
              sizeClass="p-button-sm"
              severity="primary"
              [textButton]="!_mappedRide.hasNote"
              [outlinedButton]="_mappedRide.hasNote"
              (btnClick)="openRideActivityDialog(_mappedRide)"></app-button>
            <app-button
              pTooltip="Map"
              [tooltipOptions]="tooltipOptions"
              [iconOnlyButton]="true"
              icon="icon-map-pin-solid"
              sizeClass="p-button-sm"
              severity="primary"
              [textButton]="true"
              (btnClick)="openMapDialog(_mappedRide)"></app-button>
          </div>
          <div class="flex gap-spacing-xs justify-content-center btns-group">
            <div>
              <app-button
                (btnClick)="openMenu($event, menu)"
                [iconOnlyButton]="true"
                icon="icon-list"
                sizeClass="p-button-sm"
                severity="primary"
                [outlinedButton]="true"></app-button>
              <p-menu
                [appendTo]="'body'"
                #menu
                [model]="menuItems"
                [popup]="true"
                (onHide)="onHideMenu($event, item)"
                (onShow)="onShowMenu($event, item)" />
            </div>
            <app-button
              (btnClick)="toggleRide(_mappedRide)"
              [iconOnlyButton]="true"
              [icon]="activeRide() ? 'icon-caret-left' : 'icon-caret-right'"
              sizeClass="p-button-sm"
              severity="primary"
              [outlinedButton]="true"></app-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #statusTooltip>
    <div class="tooltip-body">
      <div class="item">
        <span class="border-neutral-base-primary-color flex align-items-center">
          <i class="text-xl mr-spacing-2xs icon-warning-solid feedback-warning-fg-color"></i>
          Attention Needed
        </span>
      </div>
      <div class="item">
        <ul class="mb-0 pl-0 list-none">
          <li style="max-width: 240px">{{ _mappedRide.attentionTooltip?.description }}</li>
        </ul>
      </div>
    </div>
  </ng-template>
  <ng-template #monitorDetailsTooltip>
    <div class="tooltip-body">
      <div class="item flex gap-spacing-xs flex-row justify-content-between">
        <span class="text-inverse-color flex align-items-center">
          <span
            [ngClass]="{
              'icon-lightest-bg': !monitorAvailability(),
              'text-success-subtle-color': monitorAvailability()
            }"
            style="width: 0.5rem; height: 0.5rem"
            class="mr-spacing-2xs display-block border-circle">
          </span>
          {{ _mappedRide.monitorDetails?.name }}
        </span>
        <i
          (click)="openContractorDialog(true)"
          (keydown.enter)="openContractorDialog(true)"
          class="cursor-pointer text-xl icon-arrow-square-out-solid background-muted-brand-color"></i>
      </div>
      <div class="item flex-row gap-0">
        #<span class="monitor-id underline">{{ _mappedRide.monitorDetails?.id }}</span>
      </div>
    </div>
  </ng-template>
  <ng-template #clientListTooltip>
    <div class="tooltip-body">
      <ul class="m-0 pl-spacing-xl">
        @for (client of _mappedRide.clientDetails; track $index) {
          <li>
            <span style="margin-inline-start: -0.25rem">{{ client.name }}</span>
          </li>
        }
      </ul>
    </div>
  </ng-template>
  <ng-template #equipmentsTooltip>
    <div class="tooltip-head">
      <div class="item flex gap-spacing-2xs flex-row justify-content-between align-items-center">
        <span class="text-inverse-color flex align-items-center gap-spacing-2xs">
          <span
            class="equipments-need-dot"
            [ngClass]="{
              'icon-lightest-bg': _mappedRide.equipmentsNeed?.equipmentsNeed == equipmentsNeed.NoEquipmentRequired,
              'icon-danger-bg': _mappedRide.equipmentsNeed?.equipmentsNeed == equipmentsNeed.RequiredButNotAssigned,
              'icon-success-subtle-bg': _mappedRide.equipmentsNeed?.equipmentsNeed == equipmentsNeed.RequiredAndAssigned
            }"></span>
          {{ _mappedRide.equipmentsNeed?.description ?? "No Equipment Rquired" }}
          @if (_mappedRide.equipmentsNeed?.equipmentsNeed != equipmentsNeed.NoEquipmentRequired) {
            <span>({{ _mappedRide.equipmentsNeed?.equipmentsNeed == equipmentsNeed.RequiredAndAssigned ? _mappedRide.equipmentAssignmentResult.requiredAndAssigned?.total : _mappedRide.equipmentAssignmentResult.requiredButNotAssigned?.total }})</span>
          }
        </span>
        @if (_mappedRide.equipmentsNeed?.equipmentsNeed != equipmentsNeed.NoEquipmentRequired) {
          <i
            (click)="openEquipmentDialog()"
            (keydown.enter)="openEquipmentDialog()"
            class="cursor-pointer text-xl border-round-sm p-spacing-3xs background-surface-base-alpha-10-bg icon-arrow-square-out-solid"></i>
        }
      </div>
    </div>
    @if (_mappedRide.equipmentsNeed?.equipmentsNeed != equipmentsNeed.NoEquipmentRequired) {
      <div class="tooltip-body">
        @if (_mappedRide.equipmentsNeed?.equipmentsNeed == equipmentsNeed.RequiredAndAssigned) {
          <!-- Single section for fully assigned equipments -->
          <ng-container
            [ngTemplateOutlet]="equipmentSection"
            [ngTemplateOutletContext]="{
              equipments: _mappedRide.equipmentAssignmentResult.requiredAndAssigned?.equipments,
              title: null
            }">
          </ng-container>
        } @else {
          <!-- Multiple sections for partially assigned equipments -->
          @if (_mappedRide.equipmentAssignmentResult.requiredButNotAssigned?.equipments?.length) {
            <ng-container
              [ngTemplateOutlet]="equipmentSection"
              [ngTemplateOutletContext]="{
                equipments: _mappedRide.equipmentAssignmentResult.requiredButNotAssigned?.equipments,
                title: 'Required & Not Assigned'
              }">
            </ng-container>
          }
          @if (_mappedRide.equipmentAssignmentResult.requiredAndAssigned?.equipments?.length) {
            <ng-container
              [ngTemplateOutlet]="equipmentSection"
              [ngTemplateOutletContext]="{
                equipments: _mappedRide.equipmentAssignmentResult.requiredAndAssigned?.equipments,
                title: 'Required & Assigned'
              }">
            </ng-container>
          }
        }
      </div>
    }
  </ng-template>
  <!-- Reusable equipment section template -->
  <ng-template
    #equipmentSection
    let-equipments="equipments"
    let-title="title">
    <div class="item flex-row gap-0">
      <ul class="list-none m-0 pl-spacing-3xs">
        @if (title) {
          <span class="form-border-default-color">{{ title }}</span>
        }
        @for (equipment of equipments; track $index) {
          <li class="pl-spacing-3xs flex gap-spacing-xs align-items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="#fff"
              viewBox="0 0 16 16">
              <path
                d="M14.7202 6.94212C15.0015 6.66082 15.1596 6.27929 15.1596 5.88146C15.1596 5.48364 15.0015 5.10211 14.7202 4.8208L11.8918 1.99237C11.6411 1.74556 11.3117 1.59471 10.9611 1.56617C10.6104 1.53764 10.2609 1.63325 9.97366 1.83628C9.68638 2.03931 9.4796 2.33685 9.38947 2.67689C9.29933 3.01693 9.33157 3.37783 9.48055 3.6965L5.88138 7.29568C5.47377 7.70312 5.21946 8.23887 5.16147 8.81228C5.10349 9.38568 5.2454 9.96151 5.56318 10.4423C5.55077 10.4534 5.53897 10.4652 5.52783 10.4777L3.76006 12.2454C3.66629 12.1517 3.53912 12.099 3.40651 12.099C3.2739 12.099 3.14672 12.1517 3.05295 12.2454C2.95919 12.3392 2.90651 12.4664 2.90651 12.599C2.90651 12.7316 2.95919 12.8588 3.05295 12.9525L3.76006 13.6596C3.85383 13.7534 3.98101 13.8061 4.11361 13.8061C4.24622 13.8061 4.3734 13.7534 4.46717 13.6596C4.56094 13.5659 4.61361 13.4387 4.61361 13.3061C4.61361 13.1735 4.56094 13.0463 4.46717 12.9525L6.23493 11.1848C6.24735 11.1736 6.25915 11.1618 6.27029 11.1494C6.75109 11.4672 7.32691 11.6091 7.90031 11.5511C8.47372 11.4931 9.00947 11.2388 9.41691 10.8312L13.0161 7.23204C13.2953 7.36541 13.609 7.40914 13.9141 7.35724C14.2192 7.30533 14.5008 7.16034 14.7202 6.94212ZM10.8311 8.00278L8.70981 5.88146L10.124 4.46725L12.2453 6.58857L10.8311 8.00278ZM6.58849 10.1241C6.30718 9.8428 6.14915 9.46127 6.14915 9.06344C6.14915 8.66562 6.30718 8.28409 6.58849 8.00278L8.0027 6.58857L10.124 8.70989L8.70981 10.1241C8.4285 10.4054 8.04697 10.5634 7.64915 10.5634C7.25132 10.5634 6.86979 10.4054 6.58849 10.1241Z" />
            </svg>
            <span style="margin-inline-start: -0.25rem">{{ equipment.equipment.equipment_name + " (" + equipment.quantity + ")" }}</span>
          </li>
        }
      </ul>
    </div>
  </ng-template>
  <ng-template #vehicleDetailsTooltip>
    <div
      class="wrapper"
      style="min-width: 252px">
      <div class="tooltip-head flex justify-content-between align-items-center">
        <span class="title flex gap-spacing-xs align-items-center">
          <span
            class="icon"
            [ngClass]="{
              'icon-van-solid': _mappedRide.driverDetails?.driverCarType?.toLowerCase() == 'large vehicle',
              'icon-car-solid': _mappedRide.driverDetails?.driverCarType?.toLowerCase() != 'large vehicle'
            }"></span>
          {{ _mappedRide.driverDetails?.driverCarType }}
        </span>
      </div>
      <div class="tooltip-body">
        <div class="item">
          <span class="border-neutral-base-primary-color">Plate Number</span>
          <span>{{ _mappedRide.driverDetails?.plateNumber }}</span>
        </div>
        <div class="item">
          <span class="border-neutral-base-primary-color">Manufacturer - Model - Color</span>
          <span>{{ _mappedRide.driverDetails?.vehicleManufacturer }} {{ _mappedRide.driverDetails?.vehicleModel }} - {{ _mappedRide.driverDetails?.vehicleColor }}</span>
        </div>
        <div class="item">
          <span class="border-neutral-base-primary-color">Year</span>
          <span>{{ _mappedRide.driverDetails?.vehicleYear }}</span>
        </div>
        <div class="item">
          <span class="border-neutral-base-primary-color">Blueprint Vehicle</span>
          <span>{{ _mappedRide.driverDetails?.blueprintCarType }}</span>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #cancellationReasonDetailsTemplate>
    <div
      class="flex align-items-center gap-spacing-xs"
      style="max-width: 290px">
      @if (_mappedRide.cancellationReasonDetails?.reasonId === 1) {
        <img
          class="w-icon-lg h-icon-lg"
          src="assets/images/weather-cancellation.svg"
          alt="" />
      }
      <span class="block label-medium-medium text-inverse-color">
        {{ _mappedRide.cancellationReasonDetails?.message }}
      </span>
    </div>
  </ng-template>
}
